import React from 'react';
import { List } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { timeFromNow } from '@nxsys/helpers/DateHelper';
import {
  StyledNotifyListItem,
  StyledNotifyMsgAvatar,
} from './NotificationItem.styled';

type NotificationItemProps = {
  item: {
    id: string;
    content: string;
    notificationType: string;
    isRead: boolean;
    createdAt: string;
    author?: string;
  };
  onClick?: () => void;
};

const NotificationItem: React.FC<NotificationItemProps> = ({ item, onClick }) => {
  return (
    <StyledNotifyListItem
      className="item-hover"
      $isUnread={!item.isRead}
      onClick={onClick}
    >
      <List.Item.Meta
        avatar={
          <StyledNotifyMsgAvatar icon={<BellOutlined />} />
        }
        title={item.content}
        description={item.createdAt ? timeFromNow(item.createdAt) : ''}
      />
    </StyledNotifyListItem>
  );
};

export default NotificationItem;
